export const ROOMS_LIST_STALE_TIME = 1000 * 30; // 30 seconds
